export default "/assets/Icon/GreenTick.svg"